// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EU5OnG9Y {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  z-index: 2000;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
}
.op9GWVqJ {
  position: relative;
  background: #ffffff;
  border-radius: 0.75rem;
  max-width: 25rem;
  width: 100%;
  padding: 0;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  -webkit-animation: Ahg0kVSH 0.3s ease;
          animation: Ahg0kVSH 0.3s ease;
  overflow: hidden;
}
@media (max-width: 767px) {
  .op9GWVqJ {
    max-width: 90%;
  }
}
@media (min-width: 1024px) {
  .op9GWVqJ {
    max-width: 30rem;
  }
}
@-webkit-keyframes Ahg0kVSH {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes Ahg0kVSH {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
.AHoSyi2Q {
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  color: #585858;
  z-index: 10;
}
.AHoSyi2Q:hover {
  background: #ffffff;
}
.AHoSyi2Q:active {
  -webkit-transform: scale(0.95);
          transform: scale(0.95);
}
@media (max-width: 767px) {
  .AHoSyi2Q {
    width: 1.75rem;
    height: 1.75rem;
  }
}
.I0dJlpQ6 {
  background: #fb7901;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
}
@media (max-width: 767px) {
  .I0dJlpQ6 {
    padding: 1rem 1rem 0.5rem;
  }
}
@media (min-width: 1024px) {
  .I0dJlpQ6 {
    padding: 1rem 1.5rem;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .I0dJlpQ6 {
    padding: 0.5rem;
  }
}
.e0RTSPbg {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
}
.ksmCzauK {
  font-weight: bold;
  color: #ffffff;
}
@media (max-width: 767px) {
  .ksmCzauK {
    font-size: 1.5rem;
  }
}
@media (min-width: 1024px) {
  .ksmCzauK {
    font-size: 2rem;
  }
}
.IX0ilccU {
  width: 2.25rem;
  height: 2.25rem;
  -o-object-fit: contain;
     object-fit: contain;
  display: block;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .IX0ilccU {
    width: 2rem;
    height: 2rem;
  }
}
@media (min-width: 1024px) {
  .IX0ilccU {
    width: 3rem;
    height: 3rem;
  }
}
.dvl74LRa {
  padding: 1rem 1.5rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
}
@media (max-width: 767px) {
  .dvl74LRa {
    padding: 1rem 1rem;
  }
}
.gjEmS2PO {
  width: auto;
  height: 2.5rem;
  -o-object-fit: contain;
     object-fit: contain;
  display: block;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .gjEmS2PO {
    height: 5rem;
  }
}
@media (min-width: 1024px) {
  .gjEmS2PO {
    height: 5rem;
  }
}
.Ci6weIkw {
  font-size: 1.125rem;
  color: #585858;
  font-weight: 600;
}
@media (max-width: 767px) {
  .Ci6weIkw {
    font-size: 1rem;
  }
}
.LQ4GV5UQ {
  padding: 0 1.5rem 1.5rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 1rem;
}
@media (max-width: 767px) {
  .LQ4GV5UQ {
    padding: 0 1rem 1rem;
    gap: 0.5rem;
  }
}
.uKixh81J {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 0.25rem;
}
.TpCqxV6V {
  font-size: 0.75rem;
  color: #f5222d;
  margin-top: 0.25rem;
  line-height: 1.4;
}
@media (max-width: 767px) {
  .TpCqxV6V {
    font-size: 0.75rem;
  }
}
.yWQ_F6Pc {
  width: 100%;
  height: 3rem;
  padding: 0 1rem;
  border: 1px solid #e8e8e8;
  border-radius: 0.5rem;
  font-size: 1rem;
  color: #585858;
  outline: none;
  -webkit-transition: border-color 0.2s ease;
  transition: border-color 0.2s ease;
  background: #f0f0f0;
}
.yWQ_F6Pc:focus {
  border-color: #1890ff;
}
.yWQ_F6Pc::-webkit-input-placeholder {
  color: #cccccc;
}
.yWQ_F6Pc::-moz-placeholder {
  color: #cccccc;
}
.yWQ_F6Pc::placeholder {
  color: #cccccc;
}
@media (max-width: 767px) {
  .yWQ_F6Pc {
    padding: 0 0.5rem;
    font-size: 0.875rem;
  }
}
.lA8J5cGz {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  gap: 0.5rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  width: 100%;
  min-width: 0;
}
.Ktj2rkjK {
  background: #f0f0f0;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  min-width: 0;
  height: 3rem;
  padding: 0 1rem;
  border: 1px solid #e8e8e8;
  border-radius: 0.5rem;
  font-size: 1rem;
  color: #585858;
  outline: none;
  -webkit-transition: border-color 0.2s ease;
  transition: border-color 0.2s ease;
}
.Ktj2rkjK:focus {
  border-color: #1890ff;
}
.Ktj2rkjK::-webkit-input-placeholder {
  color: #cccccc;
}
.Ktj2rkjK::-moz-placeholder {
  color: #cccccc;
}
.Ktj2rkjK::placeholder {
  color: #cccccc;
}
@media (max-width: 767px) {
  .Ktj2rkjK {
    padding: 0 0.5rem;
    font-size: 0.875rem;
  }
}
.vEWt5a1l {
  width: 8.5rem;
  height: 3rem;
  border: 1px solid #e8e8e8;
  border-radius: 0.5rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  background: #f0f0f0;
  color: #626cda;
  font-size: 1.125rem;
  font-weight: bold;
  font-family: monospace;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
@media (max-width: 767px) {
  .vEWt5a1l {
    font-size: 1rem;
    width: 7rem;
    max-width: 40%;
  }
}
.JHCNrsBG {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
}
.JHCNrsBG::after {
  content: '';
  width: 1.4rem;
  height: 1.4rem;
  border: 2px solid #d0d0d0;
  border-top-color: #1890ff;
  border-radius: 50%;
  -webkit-animation: Z4nBBmnM 0.8s linear infinite;
          animation: Z4nBBmnM 0.8s linear infinite;
}
@-webkit-keyframes Z4nBBmnM {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes Z4nBBmnM {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.IM4vIx9F {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 0.5rem;
  margin: 0.5rem 0;
}
.s8GPRhmT {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.wQN8nXim {
  width: 1.125rem;
  height: 1.125rem;
  cursor: pointer;
  margin-top: 0.125rem;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid #d0d0d0;
  border-radius: 0.25rem;
  background: #ffffff;
  position: relative;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.wQN8nXim:checked {
  border-color: #5B5B5B;
  background: #5B5B5B;
}
.wQN8nXim:checked::after {
  content: '';
  position: absolute;
  top: 0.125rem;
  left: 0.3125rem;
  width: 0.25rem;
  height: 0.5rem;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
          transform: rotate(45deg);
}
.wQN8nXim:hover {
  border-color: #a0a0a0;
}
.akpTNald {
  font-size: 0.875rem;
  color: #c4c4c4;
  line-height: 1.5;
  font-weight: bold;
}
@media (max-width: 767px) {
  .akpTNald {
    font-size: 0.875rem;
  }
}
.TspOke8b {
  color: #1890ff;
  text-decoration: none;
  cursor: pointer;
}
.TspOke8b:hover {
  opacity: 0.8;
  text-decoration: underline;
}
.ebRjCfxY {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  gap: 0.25rem;
  padding: 0.5rem;
  border-radius: 0.25rem;
  margin-top: 0.25rem;
  width: 100%;
  text-align: center;
}
@media (max-width: 767px) {
  .ebRjCfxY {
    padding: 0.25rem 0.5rem;
  }
}
.oARyIHjo {
  color: #f5222d;
  font-size: 1rem;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
.rcBvPlaR {
  font-size: 0.875rem;
  color: #f5222d;
  line-height: 1.5;
  font-weight: bold;
}
@media (max-width: 767px) {
  .rcBvPlaR {
    font-size: 0.875rem;
  }
}
.TDeoAMfO {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
          flex-direction: column;
  gap: 1rem;
  margin-top: 0.5rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  margin-bottom: 1.5rem;
  padding: 0 10%;
}
.iNq11l8G {
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
  font-family: inherit;
  aspect-ratio: 270 / 50;
  padding: 0 1rem;
  background: #d3d3d3;
  border: none;
  border-radius: 2.5rem;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 500;
  cursor: not-allowed;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.iNq11l8G.n4XCYo7M {
  background: #1890ff;
  cursor: pointer;
}
.iNq11l8G.n4XCYo7M:hover {
  background: #0076e4;
}
.iNq11l8G.n4XCYo7M:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
.iNq11l8G:disabled {
  background: #d3d3d3;
  cursor: not-allowed;
}
@media (max-width: 767px) {
  .iNq11l8G {
    font-size: 1rem;
    width: 100%;
    max-width: 100%;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .iNq11l8G {
    width: 95%;
    font-size: 1.125rem;
  }
}
@media (min-width: 1024px) {
  .iNq11l8G {
    width: 95%;
    font-size: 1.125rem;
  }
}
.hxoq3Y_W {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  padding: 0 1rem;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 2.5rem;
  color: #585858;
  font-size: 1rem;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  min-height: 2.75rem;
  min-width: 2.75rem;
  aspect-ratio: 270 / 50;
}
.hxoq3Y_W:hover {
  background: #f5f5f5;
}
.hxoq3Y_W:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
@media (max-width: 767px) {
  .hxoq3Y_W {
    font-size: 1rem;
    width: 100%;
    max-width: 100%;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .hxoq3Y_W {
    width: 95%;
    font-size: 1.125rem;
  }
}
@media (min-width: 1024px) {
  .hxoq3Y_W {
    width: 95%;
    font-size: 1.125rem;
  }
}
.nLla_5zF {
  text-align: center;
  margin-top: 0.5rem;
}
.w40HhhDh {
  background: none;
  margin: 0;
  outline: none;
  font-family: inherit;
  color: #1890ff;
  font-size: 0.875rem;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0;
  -webkit-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
  border-bottom: 1px solid #1890ff;
}
.w40HhhDh:hover {
  opacity: 0.8;
}
@media (max-width: 767px) {
  .w40HhhDh {
    font-size: 0.75rem;
  }
}
.jcxd1X4S {
  -webkit-align-self: center;
          align-self: center;
  margin-top: 0.125rem;
}
.ynp2epGJ {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  padding: 1.5rem 0 1rem;
}
.nTpinjOh {
  width: 5rem;
  height: 5rem;
  -o-object-fit: contain;
     object-fit: contain;
}
@media (max-width: 767px) {
  .nTpinjOh {
    width: 4rem;
    height: 4rem;
  }
}
.XvE1v2Gj {
  padding: 0 1.5rem 1rem;
  text-align: center;
}
.OeJHFi4I {
  font-size: 1rem;
  color: #585858;
  line-height: 1.6;
  margin: 0 0 0.25rem 0;
}
@media (max-width: 767px) {
  .OeJHFi4I {
    font-size: 0.875rem;
  }
}
.Q7xmq0i0 {
  color: #1890ff;
}
.udIRIWCo {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  gap: 0.5rem;
  padding: 0 1.5rem 1rem;
}
@media (max-width: 767px) {
  .udIRIWCo {
    gap: 0.25rem;
    padding: 0 1rem 1.5rem;
  }
}
.L_6sNlDz {
  width: 3rem;
  height: 3rem;
  border: 2px solid #d0d0d0;
  border-radius: 0.5rem;
  text-align: center;
  font-size: 1.25rem;
  font-weight: bold;
  color: #585858;
  outline: none;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.L_6sNlDz:focus {
  border-color: #1890ff;
}
.L_6sNlDz.aD1jR3B1 {
  border-color: #1890ff;
}
.L_6sNlDz.hcJWp3gO {
  border-color: #f5222d;
}
@media (max-width: 767px) {
  .L_6sNlDz {
    width: 2.5rem;
    height: 2.5rem;
    font-size: 1.125rem;
  }
}
.hErnFAS6 {
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  outline: none;
  font-family: inherit;
  padding: 0 1rem;
  background: #d3d3d3;
  border: none;
  border-radius: 2.5rem;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 500;
  cursor: not-allowed;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  aspect-ratio: 270 / 50;
}
.hErnFAS6.oBXMq5iF {
  background: #1890ff;
  cursor: pointer;
}
.hErnFAS6.oBXMq5iF:hover {
  background: #0076e4;
}
.hErnFAS6.oBXMq5iF:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
.hErnFAS6:disabled {
  background: #d3d3d3;
  cursor: not-allowed;
}
@media (max-width: 767px) {
  .hErnFAS6 {
    font-size: 1rem;
    width: 100%;
    max-width: 100%;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .hErnFAS6 {
    width: 90%;
    font-size: 1.125rem;
  }
}
@media (min-width: 1024px) {
  .hErnFAS6 {
    width: 90%;
    font-size: 1.125rem;
  }
}
.BmTjA2G2 {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  padding: 0 1rem;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 2.5rem;
  color: #585858;
  font-size: 1rem;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  min-height: 2.75rem;
  min-width: 2.75rem;
  aspect-ratio: 270 / 50;
}
.BmTjA2G2:hover {
  background: #f5f5f5;
}
.BmTjA2G2:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
@media (max-width: 767px) {
  .BmTjA2G2 {
    font-size: 1rem;
    width: 100%;
    max-width: 100%;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .BmTjA2G2 {
    width: 90%;
    font-size: 1.125rem;
  }
}
@media (min-width: 1024px) {
  .BmTjA2G2 {
    width: 90%;
    font-size: 1.125rem;
  }
}
.MPa58VUT {
  text-align: center;
  padding: 0 1.5rem 1.5rem;
}
@media (max-width: 767px) {
  .MPa58VUT {
    padding: 0 1rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LoginModal/LoginModal.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;ECkBA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;ADnBF;AAQA;EACE,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,yCAAA;EACA,qCAAA;UAAA,6BAAA;EACA,gBAAA;AANF;ACnBE;EAAA;ID4BE,cAAA;EALF;AACF;ACZE;EAAA;IDmBE,gBAAA;EAHF;AACF;AAMA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAJF;EAMA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAJF;AACF;AAJA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAJF;EAMA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAJF;AACF;AAOA;ECuBE,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;ED1BA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,eAAA;EACA,iCAAA;EAAA,yBAAA;EACA,cAAA;EACA,WAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,8BAAA;UAAA,sBAAA;AAFJ;ACnEE;EAAA;IDyEE,cAAA;IACA,eAAA;EAFF;AACF;AAMA;EACE,mBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;AAJF;AC/EE;EAAA;IDsFE,yBAAA;EAHF;AACF;ACxEE;EAAA;ID6EE,oBAAA;EADF;AACF;ACnFE;EAAA;IDsFE,eAAA;EACF;AACF;AAEA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;AAAF;AAGA;EACE,iBAAA;EACA,cAAA;AADF;ACvGE;EAAA;ID2GE,iBAAA;EAAF;AACF;AChGE;EAAA;IDkGE,eAAA;EAEF;AACF;AACA;EACE,cAAA;EACA,eAAA;EACA,sBAAA;KAAA,mBAAA;EACA,cAAA;EACA,sBAAA;UAAA,cAAA;AACF;ACxHE;EAAA;ID0HE,WAAA;IACA,YAAA;EAEF;AACF;AClHE;EAAA;IDkHE,WAAA;IACA,YAAA;EAIF;AACF;AAAA;EACE,oBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;AAEF;AC5IE;EAAA;ID6IE,kBAAA;EAGF;AACF;AAAA;EACE,WAAA;EACA,cAAA;EACA,sBAAA;KAAA,mBAAA;EACA,cAAA;EACA,sBAAA;UAAA,cAAA;AAEF;ACxJE;EAAA;IDyJE,YAAA;EAGF;AACF;ACjJE;EAAA;IDgJE,YAAA;EAKF;AACF;AAFA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAIF;ACvKE;EAAA;IDsKE,eAAA;EAKF;AACF;AAFA;EACE,wBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,SAAA;AAIF;AClLE;EAAA;IDiLE,oBAAA;IACA,WAAA;EAKF;AACF;AAFA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,YAAA;AAIF;AADA;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAGF;ACnME;EAAA;IDmME,kBAAA;EAIF;AACF;AADA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,0CAAA;EAAA,kCAAA;EACA,mBAAA;AAGF;AADE;EACE,qBAAA;AAGJ;AAAE;EACE,cAAA;AAEJ;AAHE;EACE,cAAA;AAEJ;AAHE;EACE,cAAA;AAEJ;AC1NE;EAAA;ID4NE,iBAAA;IACA,mBAAA;EAEF;AACF;AACA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,WAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,WAAA;EACA,YAAA;AACF;AAEA;EACE,mBAAA;EACA,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,0CAAA;EAAA,kCAAA;AAAF;AAEE;EACE,qBAAA;AAAJ;AAGE;EACE,cAAA;AADJ;AAAE;EACE,cAAA;AADJ;AAAE;EACE,cAAA;AADJ;AC1PE;EAAA;ID+PE,iBAAA;IACA,mBAAA;EADF;AACF;AAIA;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;UAAA,cAAA;EACA,eAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AAFF;ACjRE;EAAA;IDsRE,eAAA;IACA,WAAA;IACA,cAAA;EADF;AACF;AAIA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;AAFF;AAIE;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gDAAA;UAAA,wCAAA;AAFJ;AAMA;EACE;IACE,iCAAA;YAAA,yBAAA;EAJF;AACF;AACA;EACE;IACE,iCAAA;YAAA,yBAAA;EAJF;AACF;AAOA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,WAAA;EACA,gBAAA;AALF;AAQA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AANF;AAUA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;UAAA,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EAAA,yBAAA;AARF;AAUE;EACE,qBAAA;EACA,mBAAA;AARJ;AAUI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,gCAAA;UAAA,wBAAA;AARN;AAYE;EACE,qBAAA;AAVJ;AAcA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAZF;ACjWE;EAAA;IDgXE,mBAAA;EAXF;AACF;AAcA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;AAZF;AAcE;EACE,YAAA;EACA,0BAAA;AAZJ;AAgBA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAdF;AC1XE;EAAA;ID2YE,uBAAA;EAbF;AACF;AAgBA;EACE,cAAA;EACA,eAAA;EACA,sBAAA;UAAA,cAAA;AAdF;AAiBA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAfF;AC1YE;EAAA;ID4ZE,mBAAA;EAdF;AACF;AAiBA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;EAAA,8BAAA;UAAA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,qBAAA;EACA,cAAA;AAfF;AAkBA;ECrWE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EDkWA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;EAAA,yBAAA;AAXF;AAaE;EACE,mBAAA;EACA,eAAA;AAXJ;AAaI;EACE,mBAAA;AAXN;AAcI;EACE,8BAAA;UAAA,sBAAA;AAZN;AAgBE;EACE,mBAAA;EAEA,mBAAA;AAfJ;ACxbE;EAAA;ID2cE,eAAA;IACA,WAAA;IACA,eAAA;EAfF;AACF;ACzbE;EAAA;ID0cE,UAAA;IACA,mBAAA;EAbF;AACF;ACzbE;EAAA;IDwcE,UAAA;IACA,mBAAA;EAXF;AACF;AAcA;ECrZE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EDiZA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;EAAA,yBAAA;ECnZA,mBAAA;EACA,kBAAA;EDoZA,sBAAA;AANF;AAQE;EACE,mBAAA;AANJ;AASE;EACE,8BAAA;UAAA,sBAAA;AAPJ;ACpeE;EAAA;ID+eE,eAAA;IACA,WAAA;IACA,eAAA;EAPF;AACF;ACreE;EAAA;ID8eE,UAAA;IACA,mBAAA;EALF;AACF;ACreE;EAAA;ID4eE,UAAA;IACA,mBAAA;EAHF;AACF;AAMA;EACE,kBAAA;EACA,kBAAA;AAJF;AAOA;EC7bE,gBAAA;EAEA,SAAA;EAEA,aAAA;EACA,oBAAA;ED0bA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,qCAAA;EAAA,6BAAA;EACA,gCAAA;AAFF;AAIE;EACE,YAAA;AAFJ;AC5gBE;EAAA;IDkhBE,kBAAA;EAFF;AACF;AAKA;EACE,0BAAA;UAAA,kBAAA;EACA,oBAAA;AAHF;AAOA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,sBAAA;AALF;AAQA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;KAAA,mBAAA;AANF;AChiBE;EAAA;IDyiBE,WAAA;IACA,YAAA;EALF;AACF;AAQA;EACE,sBAAA;EACA,kBAAA;AANF;AASA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AAPF;AChjBE;EAAA;ID0jBE,mBAAA;EANF;AACF;AASA;EACE,cAAA;AAPF;AAUA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,WAAA;EACA,sBAAA;AARF;AC9jBE;EAAA;IDykBE,YAAA;IACA,sBAAA;EAPF;AACF;AAUA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,iCAAA;EAAA,yBAAA;AARF;AAUE;EACE,qBAAA;AARJ;AAWE;EACE,qBAAA;AATJ;AAYE;EACE,qBAAA;AAVJ;ACzlBE;EAAA;IDumBE,aAAA;IACA,cAAA;IACA,mBAAA;EAVF;AACF;AAaA;ECxiBE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EDqiBA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;EAAA,yBAAA;EACA,sBAAA;AANF;AAQE;EACE,mBAAA;EACA,eAAA;AANJ;AAQI;EACE,mBAAA;AANN;AASI;EACE,8BAAA;UAAA,sBAAA;AAPN;AAWE;EACE,mBAAA;EACA,mBAAA;AATJ;AChoBE;EAAA;ID6oBE,eAAA;IACA,WAAA;IACA,eAAA;EATF;AACF;ACjoBE;EAAA;ID4oBE,UAAA;IACA,mBAAA;EAPF;AACF;ACjoBE;EAAA;ID0oBE,UAAA;IACA,mBAAA;EALF;AACF;AAQA;ECvlBE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EDmlBA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;EAAA,yBAAA;ECrlBA,mBAAA;EACA,kBAAA;EDslBA,sBAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,8BAAA;UAAA,sBAAA;AADJ;AC5qBE;EAAA;IDirBE,eAAA;IACA,WAAA;IACA,eAAA;EADF;AACF;AC7qBE;EAAA;IDgrBE,UAAA;IACA,mBAAA;EACF;AACF;AC7qBE;EAAA;ID8qBE,UAAA;IACA,mBAAA;EAGF;AACF;AAAA;EACE,kBAAA;EACA,wBAAA;AAEF;ACnsBE;EAAA;IDosBE,oBAAA;EAGF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  z-index: @z-index-modal;\n  .flex-center();\n  // padding: @spacing-md;\n\n  .mobile({\n    // padding: @spacing-md;\n  });\n}\n\n.modal {\n  position: relative;\n  background: @white;\n  border-radius: @border-radius-lg;\n  max-width: 25rem; // 400px\n  width: 100%;\n  padding: 0;\n  box-shadow: @box-shadow-lg;\n  animation: slideUp 0.3s ease;\n  overflow: hidden;\n\n  .mobile({\n    max-width: 90%;\n  });\n  .desktop({\n    max-width: 30rem;\n  });\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(1.25rem); // 20px\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.closeButton {\n  .button-reset();\n  position: absolute;\n  top: @spacing-md;\n  right: @spacing-md;\n  width: 2rem; // 32px\n  height: 2rem; // 32px\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: @text-color;\n  z-index: 10;\n\n  &:hover {\n    background: @white;\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  .mobile({\n    width: 1.75rem; // 28px\n    height: 1.75rem; // 28px\n  });\n}\n\n// TOUKA ID 头部\n.header {\n  background: #fb7901;; // 橙色背景\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .mobile({\n    padding: @spacing-md @spacing-md @spacing-sm;\n  });\n  .desktop({\n    padding: @spacing-md @spacing-lg;\n  });\n  .tablet({\n    padding: @spacing-sm;\n  });\n}\n\n.logoSection {\n  display: flex;\n  align-items: center;\n  gap: @spacing-xs;\n}\n\n.logoText {\n  font-weight: bold;\n  color: @white;\n\n  .mobile({\n    font-size: @font-size-xxl;\n  });\n  .desktop({\n    font-size: 2rem;\n  });\n}\n\n.idBadge {\n  width: 2.25rem; // 36px\n  height: 2.25rem; // 36px\n  object-fit: contain;\n  display: block;\n  flex-shrink: 0;\n\n  .mobile({\n    width: 2rem; // 32px\n    height: 2rem; // 32px\n  });\n  .desktop({\n    width: 3rem; // 40px\n    height: 3rem; // 40px\n  });\n}\n\n// 登录提示\n.loginPrompt {\n  padding: @spacing-md @spacing-lg;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: @spacing-xs;\n  justify-content: center;\n\n  .mobile({\n    padding: @spacing-md @spacing-md;\n  });\n}\n\n.arrowIcon {\n  width: auto;\n  height: 2.5rem; // 40px\n  object-fit: contain;\n  display: block;\n  flex-shrink: 0;\n\n  .mobile({\n    height: 5rem; // 80px\n  });\n  .desktop({\n    height: 5rem; // 40px\n  });\n}\n\n.promptText {\n  font-size: @font-size-lg;\n  color: #585858 ; // 黑色/深灰色文字\n  font-weight: 600;\n\n  .mobile({\n    font-size: @font-size-md;\n  });\n}\n\n.form {\n  padding: 0 @spacing-lg @spacing-lg;\n  display: flex;\n  flex-direction: column;\n  gap: @spacing-md;\n\n  .mobile({\n    padding: 0 @spacing-md @spacing-md;\n    gap: @spacing-sm;\n  });\n}\n\n.inputGroup {\n  display: flex;\n  flex-direction: column;\n  gap: @spacing-xs;\n}\n\n.fieldError {\n  font-size: @font-size-xs;\n  color: #f5222d;\n  margin-top: 0.25rem;\n  line-height: 1.4;\n\n  .mobile({\n    font-size: @font-size-xs;\n  });\n}\n\n.input {\n  width: 100%;\n  height: 3rem; // 48px，与验证码输入框高度一致\n  padding: 0 @spacing-md;\n  border: 1px solid @border-color;\n  border-radius: @border-radius-md; // 小圆角\n  font-size: @font-size-md;\n  color: @text-color;\n  outline: none;\n  transition: border-color 0.2s ease;\n  background: #f0f0f0;\n\n  &:focus {\n    border-color: @primary-color;\n  }\n\n  &::placeholder {\n    color: #cccccc; // 更浅的灰色\n  }\n\n  .mobile({\n    padding: 0 @spacing-sm;\n    font-size: @font-size-sm;\n  });\n}\n\n.captchaWrapper {\n  display: flex;\n  gap: @spacing-sm;\n  align-items: center;\n  width: 100%;\n  min-width: 0; // 防止 iOS 上 flex 子元素溢出\n}\n\n.captchaInput {\n  background: #f0f0f0;\n  flex: 1; // 宽度自适应\n  min-width: 0; // 防止 iOS 上 flex 子元素溢出\n  height: 3rem; // 48px\n  padding: 0 @spacing-md;\n  border: 1px solid @border-color;\n  border-radius: @border-radius-md; // 小圆角\n  font-size: @font-size-md;\n  color: @text-color;\n  outline: none;\n  transition: border-color 0.2s ease;\n\n  &:focus {\n    border-color: @primary-color;\n  }\n\n  &::placeholder {\n    color: #cccccc; // 更浅的灰色\n  }\n\n  .mobile({\n    padding: 0 @spacing-sm;\n    font-size: @font-size-sm;\n  });\n}\n\n.captchaImage {\n  width: 8.5rem; // 136px\n  height: 3rem; // 48px\n  border: 1px solid @border-color;\n  border-radius: @border-radius-md;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f0f0f0;\n  color: #626cda; // 紫色文字\n  font-size: @font-size-lg;\n  font-weight: bold;\n  font-family: monospace;\n  flex-shrink: 0;\n  cursor: pointer;\n  user-select: none;\n\n  .mobile({\n    font-size: @font-size-md;\n    width: 7rem; // 112px，在移动端稍微缩小\n    max-width: 40%; // 限制最大宽度，防止溢出\n  });\n}\n\n.captchaSpinner {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &::after {\n    content: '';\n    width: 1.4rem;\n    height: 1.4rem;\n    border: 2px solid #d0d0d0;\n    border-top-color: @primary-color;\n    border-radius: 50%;\n    animation: captchaSpin 0.8s linear infinite;\n  }\n}\n\n@keyframes captchaSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.checkboxes {\n  display: flex;\n  flex-direction: column;\n  gap: @spacing-sm;\n  margin: @spacing-sm 0;\n}\n\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  gap: @spacing-xs;\n  cursor: pointer;\n  user-select: none;\n  \n}\n\n.checkbox {\n  width: 1.125rem; // 18px\n  height: 1.125rem; // 18px\n  cursor: pointer;\n  margin-top: 0.125rem; // 2px\n  flex-shrink: 0;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border: 1px solid #d0d0d0; // 浅灰色边框\n  border-radius: @border-radius-sm; // 方形，小圆角\n  background: @white; // 白色内部\n  position: relative;\n  transition: all 0.2s ease;\n\n  &:checked {\n    border-color: #5B5B5B; // 深灰色边框\n    background: #5B5B5B; // 深灰色背景\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0.125rem; // 2px\n      left: 0.3125rem; // 5px\n      width: 0.25rem; // 4px\n      height: 0.5rem; // 8px\n      border: solid @white;\n      border-width: 0 2px 2px 0;\n      transform: rotate(45deg);\n    }\n  }\n\n  &:hover {\n    border-color: #a0a0a0;\n  }\n}\n\n.checkboxText {\n  font-size: @font-size-sm;\n  color: #c4c4c4; // 浅灰色文字\n  line-height: 1.5;\n  font-weight: bold;\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n}\n\n.link {\n  color: @primary-color; // 蓝色链接\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.8;\n    text-decoration: underline;\n  }\n}\n\n.errorMessage {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: @spacing-xs;\n  padding: @spacing-sm;\n  border-radius: @border-radius-sm;\n  margin-top: @spacing-xs;\n  width: 100%;\n  text-align: center;\n  \n  .mobile({\n    padding: @spacing-xs @spacing-sm;\n  });\n}\n\n.errorIcon {\n  color: @error-color;\n  font-size: @font-size-md;\n  flex-shrink: 0;\n}\n\n.errorText {\n  font-size: @font-size-sm;\n  color: #f5222d;\n  line-height: 1.5;\n  font-weight: bold;\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n}\n\n.actions {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: @spacing-sm;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding: 0 10%;\n}\n\n.loginButton {\n  .button-reset();\n  aspect-ratio: 270 / 50;\n  padding: 0 @spacing-md;\n  background: #d3d3d3; // 灰色背景（禁用状态）\n  border: none;\n  border-radius: 2.5rem; // 40px 药丸形状\n  color: @white;\n  font-size: @font-size-md;\n  font-weight: 500;\n  cursor: not-allowed;\n  transition: all 0.2s ease;\n\n  &.loginButtonEnabled {\n    background: @primary-color; // 蓝色（启用状态）\n    cursor: pointer;\n\n    &:hover {\n      background: darken(@primary-color, 10%);\n    }\n\n    &:active {\n      transform: scale(0.98);\n    }\n  }\n\n  &:disabled {\n    background: #d3d3d3;\n\n    cursor: not-allowed;\n  }\n\n  .mobile({\n    font-size: @font-size-md;\n    width: 100%;\n    max-width: 100%;\n  });\n  .tablet({\n    width: 95%;\n    font-size: @font-size-lg;\n  });\n  .desktop({\n    width: 95%;\n    font-size: @font-size-lg;\n  });\n}\n\n.cancelButton {\n  .button-reset();\n  padding: 0 @spacing-md;\n  background: @white;\n  border: 1px solid @border-color;\n  border-radius: 2.5rem; // 40px 药丸形状\n  color: @text-color;\n  font-size: @font-size-md;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  .touch-friendly();\n  aspect-ratio: 270 / 50;\n\n  &:hover {\n    background: @background-color;\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  .mobile({\n    font-size: @font-size-md;\n    width: 100%;\n    max-width: 100%;\n  });\n  .tablet({\n    width: 95%;\n    font-size: @font-size-lg;\n  });\n  .desktop({\n    width: 95%;\n    font-size: @font-size-lg;\n  });\n}\n\n.noAccountLink {\n  text-align: center;\n  margin-top: @spacing-sm;\n}\n\n.linkButton {\n  .button-reset();\n  color: @primary-color;\n  font-size: @font-size-sm;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  padding: 0;\n  transition: opacity 0.2s ease;\n  border-bottom: 1px solid @primary-color;\n\n  &:hover {\n    opacity: 0.8;\n  }\n\n  .mobile({\n    font-size: @font-size-xs;\n  });\n}\n\n.bindGameGuideButton {\n  align-self: center;\n  margin-top: 0.125rem;\n}\n\n// 验证码输入界面样式\n.emailIcon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: @spacing-lg 0 @spacing-md;\n}\n\n.mailIconImg {\n  width: 5rem; // 80px\n  height: 5rem; // 80px\n  object-fit: contain;\n\n  .mobile({\n    width: 4rem; \n    height: 4rem; \n  });\n}\n\n.instructions {\n  padding: 0 @spacing-lg @spacing-md;\n  text-align: center;\n}\n\n.instructionText {\n  font-size: @font-size-md;\n  color: @text-color;\n  line-height: 1.6;\n  margin: 0 0 @spacing-xs 0;\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n}\n\n.emailText {\n  color: @primary-color; // 蓝色邮箱地址\n}\n\n.codeInputs {\n  display: flex;\n  justify-content: center;\n  gap: @spacing-sm;\n  padding: 0 @spacing-lg @spacing-md;\n\n  .mobile({\n    gap: @spacing-xs;\n    padding: 0 @spacing-md @spacing-lg;\n  });\n}\n\n.codeInput {\n  width: 3rem; // 48px\n  height: 3rem; // 48px\n  border: 2px solid #d0d0d0; // border-width 保持 px\n  border-radius: @border-radius-md;\n  text-align: center;\n  font-size: @font-size-xl;\n  font-weight: bold;\n  color: @text-color;\n  outline: none;\n  transition: all 0.2s ease;\n\n  &:focus {\n    border-color: @primary-color;\n  }\n\n  &.codeInputFilled {\n    border-color: @primary-color;\n  }\n\n  &.codeInputError {\n    border-color: @error-color;\n  }\n\n  .mobile({\n    width: 2.5rem; // 40px\n    height: 2.5rem; // 40px\n    font-size: @font-size-lg;\n  });\n}\n\n.submitButton {\n  .button-reset();\n  padding: 0 @spacing-md;\n  background: #d3d3d3; // 灰色背景（禁用状态）\n  border: none;\n  border-radius: 2.5rem; // 40px\n  color: @white;\n  font-size: @font-size-md;\n  font-weight: 500;\n  cursor: not-allowed;\n  transition: all 0.2s ease;\n  aspect-ratio: 270 / 50;\n\n  &.submitButtonEnabled {\n    background: @primary-color; // 蓝色（启用状态）\n    cursor: pointer;\n\n    &:hover {\n      background: darken(@primary-color, 10%);\n    }\n\n    &:active {\n      transform: scale(0.98);\n    }\n  }\n\n  &:disabled {\n    background: #d3d3d3;\n    cursor: not-allowed;\n  }\n\n  .mobile({\n    font-size: @font-size-md;\n    width: 100%;\n    max-width: 100%;\n  });\n  .tablet({\n    width: 90%;\n    font-size: @font-size-lg;\n  });\n  .desktop({\n    width: 90%;\n    font-size: @font-size-lg;\n  });\n}\n\n.backButton {\n  .button-reset();\n  padding: 0 @spacing-md;\n  background: @white;\n  border: 1px solid @border-color;\n  border-radius: 2.5rem; // 40px\n  color: @text-color;\n  font-size: @font-size-md;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  .touch-friendly();\n  aspect-ratio: 270 / 50;\n\n  &:hover {\n    background: @background-color;\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  .mobile({\n    font-size: @font-size-md;\n    width: 100%;\n    max-width: 100%;\n  });\n  .tablet({\n    width: 90%;\n    font-size: @font-size-lg;\n  });\n  .desktop({\n    width: 90%;\n    font-size: @font-size-lg;\n  });\n}\n\n.troubleshootLink {\n  text-align: center;\n  padding: 0 @spacing-lg @spacing-lg;\n\n  .mobile({\n    padding: 0 @spacing-md @spacing-md;\n  });\n}\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `EU5OnG9Y`,
	"modal": `op9GWVqJ`,
	"slideUp": `Ahg0kVSH`,
	"closeButton": `AHoSyi2Q`,
	"header": `I0dJlpQ6`,
	"logoSection": `e0RTSPbg`,
	"logoText": `ksmCzauK`,
	"idBadge": `IX0ilccU`,
	"loginPrompt": `dvl74LRa`,
	"arrowIcon": `gjEmS2PO`,
	"promptText": `Ci6weIkw`,
	"form": `LQ4GV5UQ`,
	"inputGroup": `uKixh81J`,
	"fieldError": `TpCqxV6V`,
	"input": `yWQ_F6Pc`,
	"captchaWrapper": `lA8J5cGz`,
	"captchaInput": `Ktj2rkjK`,
	"captchaImage": `vEWt5a1l`,
	"captchaSpinner": `JHCNrsBG`,
	"captchaSpin": `Z4nBBmnM`,
	"checkboxes": `IM4vIx9F`,
	"checkboxLabel": `s8GPRhmT`,
	"checkbox": `wQN8nXim`,
	"checkboxText": `akpTNald`,
	"link": `TspOke8b`,
	"errorMessage": `ebRjCfxY`,
	"errorIcon": `oARyIHjo`,
	"errorText": `rcBvPlaR`,
	"actions": `TDeoAMfO`,
	"loginButton": `iNq11l8G`,
	"loginButtonEnabled": `n4XCYo7M`,
	"cancelButton": `hxoq3Y_W`,
	"noAccountLink": `nLla_5zF`,
	"linkButton": `w40HhhDh`,
	"bindGameGuideButton": `jcxd1X4S`,
	"emailIcon": `ynp2epGJ`,
	"mailIconImg": `nTpinjOh`,
	"instructions": `XvE1v2Gj`,
	"instructionText": `OeJHFi4I`,
	"emailText": `Q7xmq0i0`,
	"codeInputs": `udIRIWCo`,
	"codeInput": `L_6sNlDz`,
	"codeInputFilled": `aD1jR3B1`,
	"codeInputError": `hcJWp3gO`,
	"submitButton": `hErnFAS6`,
	"submitButtonEnabled": `oBXMq5iF`,
	"backButton": `BmTjA2G2`,
	"troubleshootLink": `MPa58VUT`
};
export default ___CSS_LOADER_EXPORT___;
